module.exports = __webpack_public_path__ + "static/task-template-apps-eee467273d98c3026083787755482a9b.svg";